import React from "react";
import styled from "styled-components";
import { Turnover } from "source/tasks/components/TaskPanel/Turnover";
import { Divider } from "@sonder/ui/source/styled/primitives/Divider";
import { TaskUnitBookingInfo } from "core/queries/GetTask";

const Container = styled.div`
  padding: 1.714rem;
`;

interface TurnoverCardProps {
  bookingInfo: TaskUnitBookingInfo;
}
export const TurnoverCard = ({ bookingInfo }: TurnoverCardProps) => {
  const { currentBooking, previousBooking, upcomingBooking } = bookingInfo;

  if (!currentBooking && !previousBooking && !upcomingBooking) return null;

  return (
    <>
      <Container>
        {previousBooking && (
          <Turnover booking={previousBooking} title="Last Turnover" />
        )}
        {currentBooking && (
          <Turnover booking={currentBooking} title="Current Turnover" />
        )}
        {upcomingBooking && (
          <Turnover booking={upcomingBooking} title="Next Turnover" />
        )}
      </Container>
      <Divider />
    </>
  );
};
